import { render, staticRenderFns } from "./AccountMenu.vue?vue&type=template&id=38c62798&scoped=true"
import script from "./AccountMenu.vue?vue&type=script&lang=ts"
export * from "./AccountMenu.vue?vue&type=script&lang=ts"
import style0 from "./AccountMenu.vue?vue&type=style&index=0&id=38c62798&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38c62798",
  null
  
)

export default component.exports